<template>
    <div id="my-profile" class="my-profile">
        <div>
            <div class="title-button">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>{{ profileTitle }}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="my-profile-data">
                <div class="row">
                    <div class="col-md-8">
                        <div class="image-profile-data">
                            <div class="logo-profile" v-if="getShowLogo">
                                <img class="logo" :src="getUrlLogo" alt="connection-logo-card" />
                            </div>

                            <div class="data">
                                <h2 class="name">{{ getProfileData.profileName }}</h2>

                                <div class="group">
                                    <StarsPPFix :starsFullNumber="Math.round(getProfileData.starsNumber)" />

                                    <div
                                        class="evaluate-stars"
                                        v-b-toggle.add-evaluation-sidebar
                                        @click="openAddEvaluationSidebar()"
                                        v-if="!isMyProfile && !isAdmin && getStatusConnection.final"
                                    >
                                        Avaliar
                                    </div>

                                    <div class="email">
                                        <b-icon icon="envelope" aria-hidden="true"></b-icon>
                                        {{ getProfileData.email }}
                                    </div>

                                    <div class="city">
                                        <b-icon icon="geo-alt" aria-hidden="true"></b-icon>
                                        {{ getProfileData.city }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <b-form-textarea
                            id="initiative-description"
                            name="initiativeDescription"
                            v-model="getProfileData.initiativeDescription"
                            placeholder="Descrição da iniciativa"
                            rows="4"
                            disabled
                        ></b-form-textarea>

                        <div class="info-objectives">
                            <div class="row">
                                <div class="col-md-7">
                                    <div class="info">
                                        <div class="text">Informações</div>
                                        <div class="row">
                                            <div class="col-md-5">
                                                <div class="connections">
                                                    <div class="image">
                                                        <img :src="require(`@/assets/people.svg`)" alt="people" />
                                                    </div>

                                                    <div class="data">
                                                        <div class="data-text">Conexões</div>

                                                        <h4 class="data-quantity">
                                                            {{ getProfileData.connectionsNumber || 0 }}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-7">
                                                <div
                                                    class="evaluation"
                                                    v-b-toggle.evaluation-recommendation-sidebar
                                                    @click="openEvaluationRecomendationSidebar()"
                                                >
                                                    <div class="image">
                                                        <img :src="require(`@/assets/star.svg`)" alt="star" />
                                                    </div>

                                                    <div class="data">
                                                        <div class="data-text">Avaliações recebidas</div>

                                                        <h4 class="data-quantity">
                                                            {{ getProfileData.evaluationNumber || 0 }}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-5">
                                    <div class="objectives">
                                        <div class="text">ODS</div>

                                        <div class="partners" v-if="getProfileData.partners">
                                            <div v-for="(partner, index) in getProfileData.partners" :key="index">
                                                <img
                                                    :src="require(`@/assets/${partner.img}`)"
                                                    alt=""
                                                    v-if="typeof partner === 'object'"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="export-btn" v-if="isMyProfile || isAdmin">
                            <b-button
                                variant="primary"
                                class="icon-button float-right"
                                size="sm"
                                :disabled="!getAllowExport"
                                v-print="'#my-profile'"
                            >
                                <b-icon icon="download" aria-hidden="true"></b-icon> Exportar
                            </b-button>
                        </div>

                        <div class="register-progress" v-if="isAdmin">
                            <label class="font-14">Andamento do cadastro</label>

                            <b-progress>
                                <b-progress-bar
                                    :value="getProgress"
                                    :label="`${getProgress}%`"
                                    :variant="getProgressBarColor"
                                ></b-progress-bar>
                            </b-progress>
                        </div>

                        <div class="compatibility-data" v-if="!isMyProfile && !isAdmin">
                            <div class="data-top-buttons" v-if="getStatusConnection.final">
                                <b-button variant="primary" class="icon-button send-msg" @click="sendHello()">
                                    <b-icon icon="envelope" aria-hidden="true"></b-icon>
                                    Manda um salve
                                </b-button>

                                <b-button variant="outline-danger" @click="undoConnection()">Desfazer conexão</b-button>

                                <span id="rg-rne-help" class="icon-tooltip">
                                    <img :src="require(`@/assets/Cadastro/responsavel/help-icon.svg`)" alt=""
                                /></span>

                                <b-tooltip target="rg-rne-help">
                                    Um salve significa mandar uma mensagem. Utilize esse recurso para conversar com as
                                    iniciativas e aproximar o relacionamento.
                                </b-tooltip>
                            </div>

                            <div class="data-top">
                                <div class="title" v-if="getStatusConnection.default || getStatusConnection.pending">
                                    Compatibilidade
                                </div>

                                <b-button
                                    variant="outline-danger"
                                    @click="cancelConnection()"
                                    v-if="
                                        getStatusConnection.pending &&
                                            getProfileData.allData.MinhaConexao.id_user ===
                                                getProfileData.allData.MinhaConexao.id_user_req
                                    "
                                    >Cancelar solicitação</b-button
                                >
                            </div>

                            <div class="align-center">
                                <vue-circle
                                    :progress="getProfileData.compatibility"
                                    :size="150"
                                    :reverse="false"
                                    line-cap="round"
                                    :fill="{ color: '#22B8CF' }"
                                    empty-fill="#99E9F2"
                                    :animation-start-value="0.0"
                                    :start-angle="30"
                                    insert-mode="append"
                                    :thickness="6"
                                    :show-percent="true"
                                ></vue-circle>

                                <div class="info">
                                    Esta iniciativa tem {{ getProfileData.compatibility }}% de compatibilidade com seu
                                    perfil.
                                </div>

                                <div v-if="getStatusConnection.default">
                                    <b-button variant="primary" @click="requestConnection()"
                                        >Solicitar conexão</b-button
                                    >
                                </div>

                                <div
                                    v-if="
                                        getStatusConnection.pending &&
                                            getProfileData.allData.MinhaConexao.id_user ===
                                                getProfileData.allData.MinhaConexao.id_user_resp
                                    "
                                >
                                    <b-button variant="dark" @click="acceptConnection()">
                                        Conectar
                                    </b-button>

                                    <b-button variant="danger" @click="cancelConnection()">
                                        Recusar
                                    </b-button>
                                </div>

                                <div
                                    class="panding-msg"
                                    v-if="
                                        getStatusConnection.pending &&
                                            getProfileData.allData.MinhaConexao.id_user ===
                                                getProfileData.allData.MinhaConexao.id_user_req
                                    "
                                >
                                    Solicitação pendente
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container" id="top-register-painel">
            <div class="my-profile-register-panel">
                <div class="content-items-form registration-flow-panel">
                    <div class="row">
                        <div class="col-12 col-md-4 padding-0">
                            <div class="left-content">
                                <h6 class="register">Cadastro</h6>

                                <div class="font-14 mb-70">Clique em uma das abas para visualizar.</div>

                                <b-form-group>
                                    <b-form-checkbox-group v-model="getProfileData.selectedStatus" name="flavour-1">
                                        <b-form-checkbox
                                            :value="option.value"
                                            :disabled="option.disabled"
                                            v-for="(option, index) in optionsStatus"
                                            :key="index"
                                            :class="{
                                                hidden: option.item === 2,
                                                link:
                                                    getProfileData.selectedStatus !== null &&
                                                    getProfileData.selectedStatus.includes(option.value)
                                            }"
                                            @click.native="itemFlowOnClick(option.value, index)"
                                        >
                                            {{ option.text }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>

                        <div class="col-12 col-md-8 padding-0">
                            <div class="right-content">
                                <FirstInformationForm1
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['PrimeirasInformacao']"
                                    v-if="getCurrentFormPlatform === 'FirstInformationForm1'"
                                ></FirstInformationForm1>

                                <FirstInformationForm2
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :showLock="!isPlatform && !isAdmin"
                                    :allowAuthorization="isPlatform"
                                    :abbleNextPage="getProfileData.allData['SobreOrganizacao'] !== null"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['PrimeirasInformacao']"
                                    v-if="getCurrentFormPlatform === 'FirstInformationForm2'"
                                ></FirstInformationForm2>

                                <FirstInformationForm3
                                    :disabled="true"
                                    :editionMode="getEditionMode"
                                    :isPlatform="true"
                                    v-if="getCurrentFormPlatform === 'FirstInformationForm3'"
                                ></FirstInformationForm3>

                                <AboutLegalGuardianForm1
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :showLock="!isPlatform && !isAdmin"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['ResponsavelLegal']"
                                    v-if="getCurrentFormPlatform === 'AboutLegalGuardianForm1'"
                                ></AboutLegalGuardianForm1>

                                <AboutLegalGuardianForm2
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :abbleNextPage="getProfileData.allData['SobreOrganizacao'] !== null"
                                    :showLock="!isPlatform && !isAdmin"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['ResponsavelLegal']"
                                    v-if="getCurrentFormPlatform === 'AboutLegalGuardianForm2'"
                                ></AboutLegalGuardianForm2>

                                <AboutLegalGuardianForm3
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :abbleNextPage="getProfileData.allData['SobreOrganizacao'] !== null"
                                    :showLock="!isPlatform && !isAdmin"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['ResponsavelLegal']"
                                    v-if="getCurrentFormPlatform === 'AboutLegalGuardianForm3'"
                                ></AboutLegalGuardianForm3>

                                <AboutInitiativeForm1
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :showLock="!isPlatform && !isAdmin"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm1'"
                                ></AboutInitiativeForm1>

                                <AboutInitiativeForm2
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :showLock="!isPlatform && !isAdmin"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm2'"
                                ></AboutInitiativeForm2>

                                <AboutInitiativeForm3
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm3'"
                                ></AboutInitiativeForm3>

                                <AboutInitiativeForm4
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm4'"
                                ></AboutInitiativeForm4>

                                <AboutInitiativeForm5
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm5'"
                                ></AboutInitiativeForm5>

                                <AboutInitiativeForm6
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm6'"
                                ></AboutInitiativeForm6>

                                <AboutInitiativeForm7
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    :receiveFirstData="
                                        !isOutsideData ? null : getProfileData.allData['PrimeirasInformacao']
                                    "
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm7'"
                                ></AboutInitiativeForm7>

                                <AboutInitiativeForm8
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm8'"
                                ></AboutInitiativeForm8>

                                <AboutInitiativeForm9
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveFirstData="
                                        !isOutsideData ? null : getProfileData.allData['PrimeirasInformacao']
                                    "
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm9'"
                                ></AboutInitiativeForm9>

                                <AboutInitiativeForm10
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm10'"
                                ></AboutInitiativeForm10>

                                <AboutInitiativeForm11
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :abbleNextPage="getProfileData.allData['PlanejamentoGestao'] !== null"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm11'"
                                ></AboutInitiativeForm11>

                                <AboutInitiativeForm12
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    :receiveFirstData="
                                        !isOutsideData ? null : getProfileData.allData['PrimeirasInformacao']
                                    "
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm12'"
                                ></AboutInitiativeForm12>

                                <AboutInitiativeForm13
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm13'"
                                ></AboutInitiativeForm13>

                                <AboutInitiativeForm14
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['SobreOrganizacao']"
                                    v-if="getCurrentFormPlatform === 'AboutInitiativeForm14'"
                                ></AboutInitiativeForm14>

                                <ManagementPlanningForm1
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :showLock="!isPlatform && !isAdmin"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['PlanejamentoGestao']"
                                    v-if="getCurrentFormPlatform === 'ManagementPlanningForm1'"
                                ></ManagementPlanningForm1>

                                <ManagementPlanningForm2
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :showLock="!isPlatform && !isAdmin"
                                    :abbleNextPage="getProfileData.allData['SustentabilidadeFinanceira'] !== null"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['PlanejamentoGestao']"
                                    v-if="getCurrentFormPlatform === 'ManagementPlanningForm2'"
                                ></ManagementPlanningForm2>

                                <FinancialSustainabilityForm1
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :showLock="!isPlatform && !isAdmin"
                                    :allowAuthorization="isPlatform"
                                    :abbleNextPage="getProfileData.allData['RedesParceiro'] !== null"
                                    :receiveData="
                                        !isOutsideData ? null : getProfileData.allData['SustentabilidadeFinanceira']
                                    "
                                    v-if="getCurrentFormPlatform === 'FinancialSustainabilityForm1'"
                                ></FinancialSustainabilityForm1>

                                <NetworksPartnersForm1
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :abbleNextPage="getProfileData.allData['ResultadoImpacto'] !== null"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['RedesParceiro']"
                                    v-if="getCurrentFormPlatform === 'NetworksPartnersForm1'"
                                ></NetworksPartnersForm1>

                                <ResultsImpactsForm1
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :abbleNextPage="getProfileData.allData['Governanca'] !== null"
                                    :showLock="!isPlatform && !isAdmin"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['ResultadoImpacto']"
                                    v-if="getCurrentFormPlatform === 'ResultsImpactsForm1'"
                                ></ResultsImpactsForm1>

                                <GovernanceForm1
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm1'"
                                ></GovernanceForm1>

                                <GovernanceForm2
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm2'"
                                ></GovernanceForm2>

                                <GovernanceForm3
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm3'"
                                ></GovernanceForm3>

                                <GovernanceForm4
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm4'"
                                ></GovernanceForm4>

                                <GovernanceForm5
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm5'"
                                ></GovernanceForm5>

                                <GovernanceForm6
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm6'"
                                ></GovernanceForm6>

                                <GovernanceForm7
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm7'"
                                ></GovernanceForm7>

                                <GovernanceForm8
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm8'"
                                ></GovernanceForm8>

                                <GovernanceForm9
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm9'"
                                ></GovernanceForm9>

                                <GovernanceForm10
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :abbleNextPage="getProfileData.allData['Governanca'] !== null"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Governanca']"
                                    v-if="getCurrentFormPlatform === 'GovernanceForm10'"
                                ></GovernanceForm10>

                                <AttachmentsForm1
                                    :disabled="true"
                                    :userIdLogged="getProfileData.idUserLogged"
                                    :editionMode="getEditionMode"
                                    :showFooterButtons="true"
                                    :isPlatform="isPlatform"
                                    :allowAuthorization="isPlatform"
                                    :showLock="!isPlatform && !isAdmin"
                                    :receiveData="!isOutsideData ? null : getProfileData.allData['Anexos']"
                                    v-if="getCurrentFormPlatform === 'AttachmentsForm1'"
                                ></AttachmentsForm1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-sidebar
            id="add-evaluation-sidebar"
            title="Adicionar avaliação"
            backdrop
            shadow
            right
            :no-close-on-backdrop="true"
        >
            <div>
                <h2>{{ getProfileData.profileName }}</h2>

                <div>Avaliar</div>

                <StarsPP ref="evaluation" :starsFullNumber="starsNumber" :allowClick="true" />

                <b-form @submit.stop.prevent="onSidebarSubmit" novalidate>
                    <label for="testimony">Depoimento</label>

                    <b-form-textarea
                        id="testimony"
                        name="testimony"
                        class="radius-6"
                        v-model="sidebarForm.testimony"
                        placeholder="Digite aqui ..."
                        rows="6"
                    ></b-form-textarea>

                    <b-button
                        type="submit"
                        :variant="!getIsDarkTheme ? 'dark' : 'primary'"
                        class="radius-6 submit"
                        @click="submitEvaluation()"
                    >
                        Avaliar
                    </b-button>
                </b-form>
            </div>
        </b-sidebar>

        <b-sidebar
            id="evaluation-recommendation-sidebar"
            title="Avaliações e recomendações"
            backdrop
            shadow
            right
            :no-close-on-backdrop="true"
        >
            <h3 class="title">{{ getProfileData.profileName }}</h3>

            <div class="evaluation-card" v-for="(item, index) in evaluationSidebar" :key="index">
                <img class="logo" :src="require(`@/assets/connection-logo-card.svg`)" alt="connection-logo-card" />

                <div class="data">
                    <div class="msg-box" :class="getKindMessage(item.id_avaliador)">
                        <div class="name-date">
                            <div class="name">{{ item.name }}</div>

                            <div class="date">{{ getDateTimeFormat(item.created_at) }}</div>
                        </div>

                        <StarsPP :starsFullNumber="item.estrela" />

                        <div class="msg">
                            {{ item.depoemento }}
                        </div>
                    </div>

                    <div class="answer" @click="showEvaluationAnswer(index)">
                        <div>Responder avaliação</div>
                    </div>

                    <div class="sub-answer" v-for="answer in item.Resposta" :key="answer.id">
                        <div class="msg-box" :class="getKindMessage(answer.id_pessoa_resposta)">
                            <div class="name-date">
                                <div class="name">{{ answer.name }}</div>
                                <div class="date">{{ getDateTimeFormat(answer.created_at) }}</div>
                            </div>

                            <div class="msg">{{ answer.mensagem }}</div>
                        </div>
                    </div>

                    <div class="answer align-right" @click="showEvaluationAnswer(index)">Responder</div>

                    <div
                        class="answer-field"
                        v-if="evaluationListSidebar.show && evaluationListSidebar.indexList === index"
                    >
                        <b-form-textarea
                            id="answer-field"
                            v-model="evaluationListSidebar.answer"
                            placeholder="Digite aqui ..."
                            rows="3"
                            max-rows="4"
                        ></b-form-textarea>

                        <div class="btn-footer">
                            <b-button variant="danger" @click="hideEvaluationAnswer()">Cancelar</b-button>

                            <b-button variant="primary" @click="answerEvaluation(item)">Enviar</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-sidebar>

        <b-modal
            ref="success-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <SuccessMsgModal :msg="messageModal" />
            </div>

            <div class="footer-buttons">
                <b-button variant="success" @click="hideModal('success-modal-ref')">
                    Entendi
                </b-button>
            </div>
        </b-modal>

        <b-modal
            ref="warning-my-profile-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <WarningMsgModal :msg="messageModal" />
            </div>

            <div class="footer-buttons">
                <b-button variant="warning" @click="$refs['warning-my-profile-modal-ref'].hide()">
                    Fechar
                </b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="messageModal" />
    </div>
</template>

<script>
import StarsPP from '@/ui/stars-pp/StarsPP'
import StarsPPFix from '@/ui/stars-pp/StarsPPFix'
import VueCircle from 'vue2-circle-progress'
import FirstInformationForm1 from '@/components/register-first-information-forms/FirstInformationForm1'
import FirstInformationForm2 from '@/components/register-first-information-forms/FirstInformationForm2'
import FirstInformationForm3 from '@/components/register-first-information-forms/FirstInformationForm3'
import AboutLegalGuardianForm1 from '@/components/register-about-legal-guardian/AboutLegalGuardianForm1'
import AboutLegalGuardianForm2 from '@/components/register-about-legal-guardian/AboutLegalGuardianForm2'
import AboutLegalGuardianForm3 from '@/components/register-about-legal-guardian/AboutLegalGuardianForm3'
import AboutInitiativeForm1 from '@/components/register-about-initiative-forms/AboutInitiativeForm1'
import AboutInitiativeForm2 from '@/components/register-about-initiative-forms/AboutInitiativeForm2'
import AboutInitiativeForm3 from '@/components/register-about-initiative-forms/AboutInitiativeForm3'
import AboutInitiativeForm4 from '@/components/register-about-initiative-forms/AboutInitiativeForm4'
import AboutInitiativeForm5 from '@/components/register-about-initiative-forms/AboutInitiativeForm5'
import AboutInitiativeForm6 from '@/components/register-about-initiative-forms/AboutInitiativeForm6'
import AboutInitiativeForm7 from '@/components/register-about-initiative-forms/AboutInitiativeForm7'
import AboutInitiativeForm8 from '@/components/register-about-initiative-forms/AboutInitiativeForm8'
import AboutInitiativeForm9 from '@/components/register-about-initiative-forms/AboutInitiativeForm9'
import AboutInitiativeForm10 from '@/components/register-about-initiative-forms/AboutInitiativeForm10'
import AboutInitiativeForm11 from '@/components/register-about-initiative-forms/AboutInitiativeForm11'
import AboutInitiativeForm12 from '@/components/register-about-initiative-forms/AboutInitiativeForm12'
import AboutInitiativeForm13 from '@/components/register-about-initiative-forms/AboutInitiativeForm13'
import AboutInitiativeForm14 from '@/components/register-about-initiative-forms/AboutInitiativeForm14'
import ManagementPlanningForm1 from '@/components/register-management-planning-forms/ManagementPlanningForm1'
import ManagementPlanningForm2 from '@/components/register-management-planning-forms/ManagementPlanningForm2'
import FinancialSustainabilityForm1 from '@/components/register-financial-sustainability/FinancialSustainabilityForm1'
import NetworksPartnersForm1 from '@/components/register-networks-partners-forms/NetworksPartnersForm1'
import ResultsImpactsForm1 from '@/components/register-results-impacts-forms/ResultsImpactsForm1'
import GovernanceForm1 from '@/components/register-governance-forms/GovernanceForm1'
import GovernanceForm2 from '@/components/register-governance-forms/GovernanceForm2'
import GovernanceForm3 from '@/components/register-governance-forms/GovernanceForm3'
import GovernanceForm4 from '@/components/register-governance-forms/GovernanceForm4'
import GovernanceForm5 from '@/components/register-governance-forms/GovernanceForm5'
import GovernanceForm6 from '@/components/register-governance-forms/GovernanceForm6'
import GovernanceForm7 from '@/components/register-governance-forms/GovernanceForm7'
import GovernanceForm8 from '@/components/register-governance-forms/GovernanceForm8'
import GovernanceForm9 from '@/components/register-governance-forms/GovernanceForm9'
import GovernanceForm10 from '@/components/register-governance-forms/GovernanceForm10'
import AttachmentsForm1 from '@/components/register-attachments-forms/AttachmentsForm1'
import IconsPP from '@/ui/icons-pp/IconsPP'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'
import { AuthenticationApi } from '../../api/authentication'
import { PlatformApi } from '../../api/platform'
import { SystemApi } from '../../api/system-api'

const platformApi = new PlatformApi()
const authenticationApi = new AuthenticationApi()
const systemApi = new SystemApi()

export default {
    components: {
        DangerModalPP,
        WarningMsgModal,
        StarsPP,
        StarsPPFix,
        FirstInformationForm1,
        FirstInformationForm2,
        FirstInformationForm3,
        AboutLegalGuardianForm1,
        AboutLegalGuardianForm2,
        AboutLegalGuardianForm3,
        AboutInitiativeForm1,
        AboutInitiativeForm2,
        AboutInitiativeForm3,
        AboutInitiativeForm4,
        AboutInitiativeForm5,
        AboutInitiativeForm6,
        AboutInitiativeForm7,
        AboutInitiativeForm8,
        AboutInitiativeForm9,
        AboutInitiativeForm10,
        AboutInitiativeForm11,
        AboutInitiativeForm12,
        AboutInitiativeForm13,
        AboutInitiativeForm14,
        ManagementPlanningForm1,
        ManagementPlanningForm2,
        FinancialSustainabilityForm1,
        NetworksPartnersForm1,
        ResultsImpactsForm1,
        GovernanceForm1,
        GovernanceForm2,
        GovernanceForm3,
        GovernanceForm4,
        GovernanceForm5,
        GovernanceForm6,
        GovernanceForm7,
        GovernanceForm8,
        GovernanceForm9,
        GovernanceForm10,
        AttachmentsForm1,
        VueCircle,
        IconsPP,
        SuccessMsgModal
    },
    props: {
        isMyProfile: {
            type: Boolean,
            default: false
        },
        isPending: {
            type: Boolean,
            default: true
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        profileTitle: {
            type: String,
            default: 'Meu Perfil'
        },
        profileData: {
            default: () => ({
                starsNumber: 0,
                profileName: '',
                initiativeDescription: null,
                email: null,
                city: null,
                partners: [],
                connectionsNumber: null,
                evaluationNumber: null,
                selectedStatus: null,
                compatibility: 0
            })
        },
        progress: {
            type: Number,
            default: 0
        },
        isOutsideData: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            messageModal: null,
            urlLogo: null,
            showLogo: false,
            goToMessage: false,
            statusConnection: {
                default: true,
                pending: false,
                final: false
            },
            starsNumber: 0,
            optionsStatus: [
                {
                    text: 'Primeiras informações',
                    item: 1,
                    value: 1,
                    disabled: true,
                    routeName: 'FirstInformationForm1'
                },
                {
                    text: 'Sobre o Responsável Legal',
                    item: 2,
                    value: 2,
                    disabled: true,
                    routeName: 'AboutLegalGuardianForm1'
                },
                { text: 'Sobre a iniciativa', item: 3, value: 3, disabled: true, routeName: 'AboutInitiativeForm1' },
                {
                    text: 'Planejamento e Gestão',
                    item: 4,
                    value: 4,
                    disabled: true,
                    routeName: 'ManagementPlanningForm1'
                },
                {
                    text: 'Sustentabilidade Financeira',
                    item: 5,
                    value: 5,
                    disabled: true,
                    routeName: 'FinancialSustainabilityForm1'
                },
                { text: 'Redes e Parceiros', item: 6, value: 6, disabled: true, routeName: 'NetworksPartnersForm1' },
                {
                    text: 'Resultados e Impactos',
                    item: 7,
                    value: 7,
                    disabled: true,
                    routeName: 'ResultsImpactsForm1'
                },
                { text: 'Governança', item: 8, value: 8, disabled: true, routeName: 'GovernanceForm1' },
                { text: 'Anexos', item: 9, value: 9, disabled: true, routeName: 'AttachmentsForm1' }
            ],
            sidebarForm: {
                testimony: null
            },
            evaluationSidebar: [],
            evaluationListSidebar: {
                show: false,
                answer: null,
                indexList: null
            },
            currentProfileData: null
        }
    },
    methods: {
        ...mapActions(['changeProfileId', 'setIsLoading', 'setProgress', 'setUserReceiveId', 'setCurrentFormPlatform']),
        showEvaluationAnswer(index) {
            this.evaluationListSidebar.show = true
            this.evaluationListSidebar.indexList = index
        },
        hideEvaluationAnswer() {
            this.evaluationListSidebar.show = false
            this.evaluationListSidebar.answer = null
            this.evaluationListSidebar.indexList = null
        },
        fetch() {
            this.setCurrentFormPlatform('FirstInformationForm1')
            this.goToMessage = false
            this.currentProfileData = this.profileData

            if (!this.isOutsideData) {
                if (Object.keys(localStorage).includes('usuario')) {
                    this.setIsLoading(true)

                    authenticationApi
                        .getUser()
                        .then(res => {
                            this.setProgress(res.data.percentual)
                            this.changeProfileId({
                                idOrganizacao: res.data.id_organizacao,
                                prestadorServico: res.data.prestador_servico
                            })

                            let idUser = null

                            if (localStorage.getItem('usuario')) {
                                idUser = JSON.parse(localStorage.getItem('usuario')).id
                            }

                            platformApi
                                .getAllProfileData(idUser)
                                .then(response => {
                                    if (response.data) {
                                        const data = response.data.data
                                        this.currentProfileData.allData = data
                                        this.currentProfileData.starsNumber = data.Estrela
                                        this.currentProfileData.email = data.PrimeirasInformacao.email
                                        this.currentProfileData.profileName = data.PrimeirasInformacao.nome_organizacao
                                        this.currentProfileData.initiativeDescription =
                                            data.PrimeirasInformacao.descricao_organizacao
                                        this.urlLogo = data.PrimeirasInformacao.url_logo
                                        this.showLogo = true
                                        this.currentProfileData.city =
                                            data.SobreOrganizacao &&
                                            data.SobreOrganizacao.cidade &&
                                            data.SobreOrganizacao.estado
                                                ? `${data.SobreOrganizacao.cidade} - ${data.SobreOrganizacao.estado}`
                                                : ''
                                        this.currentProfileData.partners = res.data.ods.map(item => ({
                                            img: `img-section2-${item}.svg`
                                        }))
                                        this.currentProfileData.connectionsNumber = data.Conexao
                                        this.currentProfileData.evaluationNumber = data.TotalAvaliacao
                                        this.currentProfileData.compatibility = data.Compatibilidade
                                        this.currentProfileData.selectedStatus = [1, 2, 3, 4, 5, 6, 7, 8, 9]
                                        this.showProfileData = true

                                        this.currentProfileData.selectedStatus = this.getRegisterFlowChecked
                                        this.scrollBehavior()
                                    }
                                })
                                .catch(error => {
                                    this.messageModal = error.response.data.message
                                    this.$refs.warningModal.showModal()
                                })
                                .finally(() => {
                                    this.setIsLoading(false)
                                })
                        })
                        .catch(error => {
                            this.setIsLoading(false)
                            this.messageModal = error.response.data.message
                            this.$refs.warningModal.showModal()
                        })
                }
            } else {
                this.setIsLoading(true)
                this.changeProfileId({
                    idOrganizacao: this.getProfileData.allData.PrimeirasInformacao.id_organizacao,
                    prestadorServico: this.getProfileData.allData.PrimeirasInformacao.prestador_servico
                })

                if (this.getProfileData.partners.length) {
                    this.currentProfileData.partners = this.getProfileData.partners.map(item => ({
                        img: `img-section2-${item}.svg`
                    }))
                }

                this.currentProfileData.selectedStatus = this.getRegisterFlowChecked

                const connection = this.getProfileData.allData.MinhaConexao
                this.urlLogo = this.getProfileData.allData.PrimeirasInformacao.url_logo
                this.showLogo = true

                if (connection !== null) {
                    ;[1, '1'].includes(connection.status)
                        ? this.updateStatusConnection('pending')
                        : this.updateStatusConnection('final')
                } else {
                    this.updateStatusConnection('default')
                }

                this.setIsLoading(false)
            }
        },
        onSidebarSubmit(event) {},
        openEvaluationRecomendationSidebar() {
            const userId = this.getProfileData.allData.PrimeirasInformacao.id_user

            this.hideEvaluationAnswer()
            this.updateProfileData(userId)
        },
        openAddEvaluationSidebar() {
            this.sidebarForm.testimony = null
            this.$refs['evaluation'].qtdStars = 0
        },
        submitEvaluation() {
            const data = {
                id_avaliado: this.getProfileData.allData.PrimeirasInformacao.id_user,
                estrela: this.$refs['evaluation'].getQtdStars(),
                depoemento: this.sidebarForm.testimony
            }

            this.setIsLoading(true)

            platformApi
                .setEvaluation(data)
                .then(response => {
                    this.messageModal = response.data.message
                    this.showModal('success-modal-ref')
                    this.updateProfileData(data.id_avaliado)
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                    this.$root.$emit('bv::toggle::collapse', 'add-evaluation-sidebar')
                })
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        updateConnectionProfileData(userId, nextKeyStatus) {
            this.setIsLoading(true)
            platformApi
                .getAllProfileData(userId)
                .then(res => {
                    if (res.data.data) {
                        const result = res.data.data
                        this.currentProfileData.allData = result
                        this.currentProfileData.connectionsNumber = result.Conexao
                        this.updateStatusConnection(nextKeyStatus)
                    }
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        updateProfileData(userId) {
            this.setIsLoading(true)
            platformApi
                .getAllProfileData(userId)
                .then(res => {
                    if (res.data.data) {
                        const result = res.data.data
                        this.currentProfileData.evaluationNumber = result.Avaliacoes.length
                        this.currentProfileData.starsNumber = result.Estrela
                        this.currentProfileData.allData = result
                        this.evaluationSidebar = result.Avaliacoes
                    }
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        undoConnection() {
            this.setIsLoading(true)

            const data = {
                id: this.getProfileData.allData.MinhaConexao.id_conexao,
                id_organizacao: this.getProfileData.allData.PrimeirasInformacao.id_user,
                compatibilidade: this.getProfileData.allData.Compatibilidade
            }
            const userId = this.getProfileData.allData.PrimeirasInformacao.id_user

            platformApi
                .setUndoConnection(data)
                .then(response => {
                    this.updateConnectionProfileData(userId, 'default')
                })
                .catch(error => {
                    this.setIsLoading(false)

                    const message = error.response.data.message
                    this.messageModal = message

                    if (message.indexOf('Conexão não encontrada') >= 0) {
                        this.updateConnectionProfileData(userId, 'default')
                    }

                    this.$refs.warningModal.showModal()
                })
        },
        requestConnection() {
            this.setIsLoading(true)

            const data = {
                id: this.getProfileData.allData.PrimeirasInformacao.id_user,
                compatibilidade: this.getProfileData.allData.Compatibilidade
            }

            platformApi
                .setRequestConnection(data)
                .then(response => {
                    this.updateConnectionProfileData(data.id, 'pending')
                })
                .catch(error => {
                    this.setIsLoading(false)
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
        },
        cancelConnection() {
            this.answerConnection(0)
        },
        acceptConnection() {
            this.answerConnection(2)
        },
        answerConnection(value) {
            this.setIsLoading(true)

            const data = { id: this.getProfileData.allData.MinhaConexao.id_conexao, option: value }
            const userId = this.getProfileData.allData.PrimeirasInformacao.id_user
            const nextKeyStatus = value === 2 ? 'final' : 'default'

            platformApi
                .answerConnection(data)
                .then(response => {
                    this.updateConnectionProfileData(userId, nextKeyStatus)
                })
                .catch(error => {
                    this.setIsLoading(false)
                    const message = error.response.data.message
                    this.messageModal = message
                    if (message.indexOf('Conexão foi cancelada') >= 0) {
                        this.updateConnectionProfileData(userId, 'default')
                    }
                    this.$refs['warning-my-profile-modal-ref'].show()
                })
        },
        updateStatusConnection(key) {
            if (key === 'default') {
                this.statusConnection = { default: true, pending: false, final: false }
            } else if (key === 'pending') {
                this.statusConnection = { default: false, pending: true, final: false }
            } else if (key === 'final') {
                this.statusConnection = { default: false, pending: false, final: true }
            }
        },
        getDateTimeFormat(dateText) {
            return systemApi.getDateTimeFormat(dateText)
        },
        answerEvaluation(item) {
            const data = {
                id_avaliacao: item.id,
                depoemento: this.evaluationListSidebar.answer,
                id_avaliado: item.id_avaliado
            }

            this.setIsLoading(true)

            platformApi
                .answerEvaluation(data)
                .then(response => {
                    this.messageModal = response.data.message
                    this.hideEvaluationAnswer()
                    this.updateProfileData(data.id_avaliado)
                    this.showModal('success-modal-ref')
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.hideEvaluationAnswer()
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        getKindMessage(evaluatorId) {
            const ratedId = this.getProfileData.allData.PrimeirasInformacao.id_user
            return evaluatorId === ratedId ? 'rated' : 'evaluator'
        },
        sendHello() {
            const userId = this.getProfileData.allData.PrimeirasInformacao.id_user
            this.setUserReceiveId(userId)
            this.goToMessagePage()
        },
        goToMessagePage() {
            this.hideModal('success-modal-ref')
            this.$router.push({ name: 'MessagesPage' })
        },
        itemFlowOnClick(value, indexItem) {
            if (this.getProfileData.selectedStatus.includes(value)) {
                const routeName = this.optionsStatus[indexItem].routeName
                this.setCurrentFormPlatform(routeName)
                this.updateRegistrationFlow()
                this.scrollBehavior()
            }
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('app')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        updateRegistrationFlow() {
            let currentItem = 0
            const routerName = this.getCurrentFormPlatform

            switch (routerName) {
                case 'FirstInformationForm1':
                case 'FirstInformationForm2':
                case 'FirstInformationForm3':
                    currentItem = 0
                    break

                // case 'AboutLegalGuardianForm1':
                // case 'AboutLegalGuardianForm2':
                // case 'AboutLegalGuardianForm3':
                //     currentItem = 1
                //     break

                case 'AboutInitiativeForm1':
                case 'AboutInitiativeForm2':
                case 'AboutInitiativeForm3':
                case 'AboutInitiativeForm4':
                case 'AboutInitiativeForm5':
                case 'AboutInitiativeForm6':
                case 'AboutInitiativeForm7':
                case 'AboutInitiativeForm8':
                case 'AboutInitiativeForm9':
                case 'AboutInitiativeForm10':
                case 'AboutInitiativeForm11':
                case 'AboutInitiativeForm12':
                case 'AboutInitiativeForm13':
                case 'AboutInitiativeForm14':
                    currentItem = 2
                    break

                case 'ManagementPlanningForm1':
                case 'ManagementPlanningForm2':
                    currentItem = 3
                    break

                case 'FinancialSustainabilityForm1':
                    currentItem = 4
                    break

                case 'NetworksPartnersForm1':
                    currentItem = 5
                    break

                case 'ResultsImpactsForm1':
                    currentItem = 6
                    break

                case 'GovernanceForm1':
                case 'GovernanceForm2':
                case 'GovernanceForm3':
                case 'GovernanceForm4':
                case 'GovernanceForm5':
                case 'GovernanceForm6':
                case 'GovernanceForm7':
                case 'GovernanceForm8':
                case 'GovernanceForm9':
                case 'GovernanceForm10':
                    currentItem = 7
                    break

                case 'AttachmentsForm1':
                    currentItem = 8
                    break

                default:
                    break
            }

            if (document.querySelectorAll('.custom-checkbox.current').length) {
                document.querySelectorAll('.custom-checkbox.current')[0].classList.remove('current')
            }

            document.querySelectorAll('.custom-checkbox')[currentItem].classList.add('current')
        }
    },
    computed: {
        getShowLogo() {
            return this.showLogo
        },
        getUrlLogo() {
            return this.urlLogo ? this.$PPP_URL_FILE + this.urlLogo : require(`@/assets/connection-logo-card.svg`)
        },
        getProfileData() {
            return this.currentProfileData ? this.currentProfileData : this.profileData
        },
        getProgress() {
            return this.progress
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getCurrentFormPlatform() {
            return this.$store.state.currentFormPlatform
        },
        getEditionMode() {
            return this.editionMode
        },
        getProgressBarColor() {
            const value = this.getProgress
            return value < 10 ? 'danger' : value >= 10 && value < 50 ? 'warning' : 'success'
        },
        getStatusConnection() {
            return this.statusConnection
        },
        getAllowExport() {
            return this.$store.state.allowExportBtn
        },
        getRegisterFlowChecked() {
            const data = this.getProfileData.allData

            if (data.Anexos) {
                return [1, 2, 3, 4, 5, 6, 7, 8, 9]
            }

            if (data.Governanca) {
                return [1, 2, 3, 4, 5, 6, 7, 8]
            }

            if (data.ResultadoImpacto) {
                return [1, 2, 3, 4, 5, 6, 7]
            }

            if (data.RedesParceiro) {
                return [1, 2, 3, 4, 5, 6]
            }

            if (data.SustentabilidadeFinanceira) {
                return [1, 2, 3, 4, 5]
            }

            if (data.PlanejamentoGestao) {
                return [1, 2, 3, 4]
            }

            if (data.SobreOrganizacao) {
                return [1, 2, 3]
            }

            if (data.ResponsavelLegal) {
                return [1, 2]
            }

            if (data.PrimeirasInformacao) {
                return [1]
            }
        }
    },
    mounted() {
        this.fetch()
    },
    updated() {
        this.updateRegistrationFlow()
    }
}
</script>

<style scope src="./MyProfile-light-theme.css"></style>
<style scope src="./MyProfile-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/components/my-profile/MyProfile.vue